import { quantidadePadrao, totalDoPedido, valorDoServico } from "@bookdental/schemas";
import { formatBRL } from "./prosthesis-meta";
import type { AcrescimoDoPedidoRow } from "./types";

type ComValor = { priceCents: number | null; quantidade?: number | null };

/** Total do pedido pra exibir: nulo quando nenhum serviço tem preço (R$ 0,00 pareceria "grátis"). */
export function totalParaExibir(servicos: ComValor[], acrescimos: Pick<AcrescimoDoPedidoRow, "valorCents">[] = []): number | null {
  if (!servicos.some((s) => s.priceCents != null)) return null;
  return totalDoPedido(servicos, acrescimos.map((a) => ({ valorCents: a.valorCents ?? 0 }))).totalCents;
}

/** "R$ 420,00" ou, com mais de uma unidade, "3 × R$ 420,00 = R$ 1.260,00". */
export function valorDoServicoEmTexto(s: ComValor): string {
  const total = valorDoServico(s);
  if (total == null) return "";
  const qtd = Math.max(s.quantidade ?? 1, 1);
  return qtd > 1 ? `${qtd} × ${formatBRL(s.priceCents)} = ${formatBRL(total)}` : formatBRL(total);
}

/** De onde sai o nº de unidades: a regra do serviço (dente ou arcada) ou um ajuste à mão do
 *  laboratório. Nulo quando a regra do serviço não veio junto. */
export function origemDasUnidades(s: { teeth?: string | null; quantidade?: number | null; abrangencia?: string | null }): string | null {
  if (!s.abrangencia) return null;
  if (Math.max(s.quantidade ?? 1, 1) !== quantidadePadrao(s.teeth, s.abrangencia)) return "ajustada à mão";
  // Serviço de arcada já nasce com as duas arcadas marcadas: conta 1 (o laboratório ajusta quando cobra por arcada).
  return s.abrangencia === "ARCADA" ? "cobrado uma vez" : "por dente";
}
